import styled from 'styled-components';

export const AboutTitleHeading = styled.div`
  h1 {
    text-transform: uppercase;
    letter-spacing: 0.125rem;
  }
`;
